import { QueryClient } from '@tanstack/react-query'

/**
 * 전역 QueryClient 인스턴스
 * LoginStore 등 외부에서도 접근 가능하도록 싱글톤으로 관리
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
})
